import {
    IQueryContext,
    IQueryContextDatasourceColumnState,
} from 'src/app/services/query-context/models/IQueryContext';
import {
    DashboardItemComponentType,
    DashboardItemFactory,
    IDatasourceColumnDashboardItem,
    IDatasourceColumnDashboardItemFactoryOptions,
} from 'src/app/utils/dashboard-item';
import { DatasourceColumnId } from 'src/app/utils/datasource-sql-map/datasource';

export interface IStringInputFilterData {
    value: string;
}

export interface IStringInputFilterDatasourceColumnState extends IQueryContextDatasourceColumnState {
    value: string;
}

export interface IStringInputFilterDatasourceColumnDashboardItem extends IDatasourceColumnDashboardItem {
    datasourceColumn: {
        id: DatasourceColumnId;
        state: IStringInputFilterDatasourceColumnState;
    };
    // override default return value of composeData function
    composeData: (a: any[], b?: IQueryContext) => IStringInputFilterData;
}

export class StringInputFilterDashboardItemFactoryOptions implements IDatasourceColumnDashboardItemFactoryOptions {
    constructor(
        /** Instance id */
        public createdInstanceId: string,
        public datasourceColumnId: DatasourceColumnId
    ) {}
}

export class StringInputFilterDashboardItemFactory extends DashboardItemFactory<
    IStringInputFilterDatasourceColumnDashboardItem,
    StringInputFilterDashboardItemFactoryOptions
> {
    override FACTORY_CLASS: string = 'StringInputFilterDashboardItemFactory';
    override COMPONENT_CLASS: DashboardItemComponentType =
        'StringInputFilterDashboardItem';

    override getInstance(
        options: StringInputFilterDashboardItemFactoryOptions
    ) {
        const instance: IStringInputFilterDatasourceColumnDashboardItem = {
            datasourceColumnId: options.datasourceColumnId,
            datasourceColumn: {
                id: options.datasourceColumnId,
                state: {
                    value: '',
                    isFilterApplied: false,
                    isSplitApplied: false,
                },
            },
            instanceId: options.createdInstanceId,
            dashboardItem: {
                id: options.datasourceColumnId,
                initialState: {
                    value: '',
                    isFilterApplied: false,
                },
            },
            component: this.COMPONENT_CLASS,
            composeData: (data: any[], context?: IQueryContext) => {
                return { value: '' };
            },
        };

        return instance;
    }
}
